import http from "@/utils/http";

export default {
    getOne(params) {
        return http.get("/api/login/announcement", params, { isEncrypt: true });
    },
};
